import { Helmet } from "react-helmet-async";

export const Seo = ({ title, description, event }) => {
  const jsonLd = event
    ? {
        "@context": "https://schema.org",
        "@type": "Event",
        name: `HÖR on Tour — Halloween Edition, ${event.city} 2026`,
        description,
        startDate: event.dateISO,
        eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
        eventStatus: "https://schema.org/EventScheduled",
        location: {
          "@type": "Place",
          name: event.venueName,
          address: event.venueAddress,
        },
        performer: ["BIIA", "TIGERHEAD", "DØMINA"].map((name) => ({
          "@type": "PerformingGroup",
          name,
        })),
        offers: {
          "@type": "Offer",
          url: event.ticketUrl,
          priceCurrency: "INR",
          price: "999",
          availability: "https://schema.org/InStock",
        },
      }
    : null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
